import { Component } from '@angular/core';

/**
 * Outlet vazio para o catch-all da folha: qualquer hash fora de LEAF_ROUTES
 * (ex: durante o desmonte da folha, ao trocar de contexto) cai aqui em vez de
 * o roteador lançar NG04002, permitindo que a navegação real seja concluída
 * fora da folha sem erro não tratado.
 */
@Component({
  selector: 'app-leaf-empty-route',
  template: '',
})
export class LeafEmptyRouteComponent {}
